import { memo, useState } from "react";
import Input from "../../components/input/input";
import styles from '../loginSignup.module.css';
import Button from "../../components/button/button";
import { useNavigate } from "react-router-dom";
import { signUpAPI } from "../../services/api";

export default memo(function SignUpComponent({ setinfoPopup, setMode }) {

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [name, setName] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [apiError, setApiError] = useState('');
    const [click, setClick] = useState(false);
    const navigate = useNavigate();
    const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).+$/;

    const handleSignUpSubmit = async () => {
        setApiError('')
        setClick(true)
        let registered = await signUpAPI(email, name, password)
        if (registered.ok) setinfoPopup({ show: true, message: "Success! Your account has been created!" });
        else {
            setApiError(registered.data?.error || registered.data?.message || 'Something went wrong , please try again')
            setClick(false)
        }
    };
    return (
        <>
            <h2>Welcome! Create your account below.</h2>
            <div className={styles.inputcontainer}>
                <Input
                    id="email"
                    label="Email address *"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                />
                <Input
                    id="name"
                    label="Username *"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                />
                <Input
                    id="password"
                    label="Password *"
                    type="password"
                    value={password}
                    style={password?.length > 0 && (password?.length < 8 || !regex.test(password)) ? { border: '1px solid red' } : null}
                    onChange={(e) => setPassword(e.target.value)}
                    errText={password?.length > 0 && (password?.length < 8 || !regex.test(password)) ? 'Password must have uppercase, lowercase, number, symbol, and be 8 or more characters.' : null}
                />
                <Input
                    id="ReEnterpassword"
                    label="Re-Enter password * "
                    type="password"
                    value={confirmPassword}
                    style={confirmPassword !== password && password?.length >= 8 && confirmPassword?.length >= 8 ? { border: '1px solid red' } : null}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    errText={confirmPassword !== password && password?.length >= 8 && confirmPassword?.length >= 8 ? 'Passwords do not match.' : null}
                />
                {apiError && <p style={{ color: 'red', fontSize: '14px', marginTop: '10px' }}>{apiError}</p>}
                <Button onClick={handleSignUpSubmit} children={'Sign Up'} style={{ marginTop: '25px' }} disabled={!regex.test(password) || confirmPassword !== password || !password || !name || !email || password?.length < 8 || click} />
            </div>
            <p style={{ marginTop: '10px', fontSize: '14px' }}>Trouble signing up?
                <span onClick={() => navigate('/support')} style={{ cursor: 'pointer', textDecoration: 'underline' }}> Contact support.</span>
            </p>
            <p style={{ marginTop: '10px', cursor: 'pointer' }} onClick={setMode} > Already have an account? <span style={{ cursor: 'pointer', textDecoration: 'underline' }}>Log in</span></p>
        </>
    )
})